"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: card/card-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcard%2Fcard-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardServiceClient = exports.GetFeesResponse = exports.GetFeesRequest = exports.UpdateCardAtmResponse = exports.UpdateCardAtmRequest = exports.CloseCardResponse = exports.CloseCardRequest = exports.UpdateCardResponse = exports.UpdateCardRequest = exports.ActivateCardResponse = exports.ActivateCardRequest = exports.ReplaceCardWithShippingResponse = exports.ReplaceCardWithShippingRequest = exports.ReplaceCardResponse = exports.ReplaceCardRequest = exports.IssueCardResponse = exports.IssueCardRequest = exports.GetCardsResponse = exports.GetCardsRequest = exports.SetCardTemplateResponse = exports.SetCardTemplateRequest = exports.GetCardTemplateResponse = exports.GetCardTemplateRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const address_1 = require("../common/address");
const card_atm_1 = require("../common/card-atm");
const card_details_1 = require("../common/card-details");
const step_color_1 = require("../common/step-color");
const card_1 = require("./card");
const card_fee_1 = require("./card-fee");
const card_template_1 = require("./card-template");
const step_card_design_1 = require("./step-card-design");
const protobufPackage = 'com.step.card.proto';
function createBaseGetCardTemplateRequest() {
    return {};
}
exports.GetCardTemplateRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetCardTemplateRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetCardTemplateRequest();
        return message;
    },
};
function createBaseGetCardTemplateResponse() {
    return { template: card_template_1.CardTemplate.fromPartial({}) };
}
exports.GetCardTemplateResponse = {
    fromJSON(object) {
        const message = {
            template: isSet(object.template)
                ? card_template_1.CardTemplate.fromJSON(object.template)
                : card_template_1.CardTemplate.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.template !== undefined) {
            obj.template = card_template_1.CardTemplate.toJSON(message.template);
        }
        return obj;
    },
    create(base) {
        return exports.GetCardTemplateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCardTemplateResponse();
        message.template = (object.template !== undefined && object.template !== null)
            ? card_template_1.CardTemplate.fromPartial(object.template)
            : card_template_1.CardTemplate.fromPartial({});
        return message;
    },
};
function createBaseSetCardTemplateRequest() {
    return { nameOnCard: '', signature: '', isCompleted: false, color: undefined, design: undefined };
}
exports.SetCardTemplateRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.nameOnCard)) {
            message.nameOnCard = globalThis.String(object.nameOnCard);
        }
        if (isSet(object.signature)) {
            message.signature = globalThis.String(object.signature);
        }
        if (isSet(object.isCompleted)) {
            message.isCompleted = globalThis.Boolean(object.isCompleted);
        }
        if (isSet(object.color)) {
            message.color = (0, step_color_1.stepColorFromJSON)(object.color);
        }
        if (isSet(object.design)) {
            message.design = step_card_design_1.StepCardDesign.fromJSON(object.design);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nameOnCard !== undefined && message.nameOnCard !== '') {
            obj.nameOnCard = message.nameOnCard;
        }
        if (message.signature !== undefined && message.signature !== '') {
            obj.signature = message.signature;
        }
        if (message.isCompleted !== undefined && message.isCompleted !== false) {
            obj.isCompleted = message.isCompleted;
        }
        if (message.color !== undefined) {
            obj.color = (0, step_color_1.stepColorToJSON)(message.color);
        }
        if (message.design !== undefined) {
            obj.design = step_card_design_1.StepCardDesign.toJSON(message.design);
        }
        return obj;
    },
    create(base) {
        return exports.SetCardTemplateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetCardTemplateRequest();
        message.nameOnCard = object.nameOnCard ?? '';
        message.signature = object.signature ?? '';
        message.isCompleted = object.isCompleted ?? false;
        message.color = object.color ?? undefined;
        message.design = (object.design !== undefined && object.design !== null)
            ? step_card_design_1.StepCardDesign.fromPartial(object.design)
            : undefined;
        return message;
    },
};
function createBaseSetCardTemplateResponse() {
    return {};
}
exports.SetCardTemplateResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetCardTemplateResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetCardTemplateResponse();
        return message;
    },
};
function createBaseGetCardsRequest() {
    return { primaryAccountId: '', includeClosed: false };
}
exports.GetCardsRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.primaryAccountId)) {
            message.primaryAccountId = globalThis.String(object.primaryAccountId);
        }
        if (isSet(object.includeClosed)) {
            message.includeClosed = globalThis.Boolean(object.includeClosed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== undefined && message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.includeClosed !== undefined && message.includeClosed !== false) {
            obj.includeClosed = message.includeClosed;
        }
        return obj;
    },
    create(base) {
        return exports.GetCardsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCardsRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.includeClosed = object.includeClosed ?? false;
        return message;
    },
};
function createBaseGetCardsResponse() {
    return { cards: [] };
}
exports.GetCardsResponse = {
    fromJSON(object) {
        const message = {
            cards: globalThis.Array.isArray(object?.cards)
                ? object.cards.map((e) => card_1.Card.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cards?.length) {
            obj.cards = message.cards.map((e) => card_1.Card.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetCardsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetCardsResponse();
        message.cards = object.cards?.map((e) => card_1.Card.fromPartial(e)) || [];
        return message;
    },
};
function createBaseIssueCardRequest() {
    return {
        primaryAccountId: '',
        nameOnCard: '',
        cardType: card_details_1.CardType.INVALID_CARD_TYPE,
        async: false,
    };
}
exports.IssueCardRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.nameOnCard)) {
            message.nameOnCard = globalThis.String(object.nameOnCard);
        }
        if (isSet(object.cardType)) {
            message.cardType = (0, card_details_1.cardTypeFromJSON)(object.cardType);
        }
        if (isSet(object.async)) {
            message.async = globalThis.Boolean(object.async);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.nameOnCard !== undefined && message.nameOnCard !== '') {
            obj.nameOnCard = message.nameOnCard;
        }
        if (message.cardType !== undefined && message.cardType !== card_details_1.CardType.INVALID_CARD_TYPE) {
            obj.cardType = (0, card_details_1.cardTypeToJSON)(message.cardType);
        }
        if (message.async !== undefined && message.async !== false) {
            obj.async = message.async;
        }
        return obj;
    },
    create(base) {
        return exports.IssueCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIssueCardRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.nameOnCard = object.nameOnCard ?? '';
        message.cardType = object.cardType ?? card_details_1.CardType.INVALID_CARD_TYPE;
        message.async = object.async ?? false;
        return message;
    },
};
function createBaseIssueCardResponse() {
    return { card: card_1.Card.fromPartial({}) };
}
exports.IssueCardResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? card_1.Card.fromJSON(object.card) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = card_1.Card.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.IssueCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIssueCardResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? card_1.Card.fromPartial(object.card)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseReplaceCardRequest() {
    return {
        cardId: '',
        reason: card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON,
        payFee: false,
    };
}
exports.ReplaceCardRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            reason: isSet(object.reason)
                ? (0, card_details_1.cardReplacementReasonFromJSON)(object.reason)
                : card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON,
        };
        if (isSet(object.payFee)) {
            message.payFee = globalThis.Boolean(object.payFee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.reason !== card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON) {
            obj.reason = (0, card_details_1.cardReplacementReasonToJSON)(message.reason);
        }
        if (message.payFee !== undefined && message.payFee !== false) {
            obj.payFee = message.payFee;
        }
        return obj;
    },
    create(base) {
        return exports.ReplaceCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReplaceCardRequest();
        message.cardId = object.cardId ?? '';
        message.reason = object.reason ?? card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON;
        message.payFee = object.payFee ?? false;
        return message;
    },
};
function createBaseReplaceCardResponse() {
    return { replacement: card_1.Card.fromPartial({}), updated: card_1.Card.fromPartial({}) };
}
exports.ReplaceCardResponse = {
    fromJSON(object) {
        const message = {
            replacement: isSet(object.replacement)
                ? card_1.Card.fromJSON(object.replacement)
                : card_1.Card.fromPartial({}),
            updated: isSet(object.updated) ? card_1.Card.fromJSON(object.updated) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.replacement !== undefined) {
            obj.replacement = card_1.Card.toJSON(message.replacement);
        }
        if (message.updated !== undefined) {
            obj.updated = card_1.Card.toJSON(message.updated);
        }
        return obj;
    },
    create(base) {
        return exports.ReplaceCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReplaceCardResponse();
        message.replacement = (object.replacement !== undefined && object.replacement !== null)
            ? card_1.Card.fromPartial(object.replacement)
            : card_1.Card.fromPartial({});
        message.updated = (object.updated !== undefined && object.updated !== null)
            ? card_1.Card.fromPartial(object.updated)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseReplaceCardWithShippingRequest() {
    return {
        cardId: '',
        reason: card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON,
        shipmentService: card_details_1.CardShippingShipmentService.INVALID_SHIPMENT_SERVICE,
    };
}
exports.ReplaceCardWithShippingRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
            reason: isSet(object.reason)
                ? (0, card_details_1.cardReplacementReasonFromJSON)(object.reason)
                : card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON,
        };
        if (isSet(object.shipmentService)) {
            message.shipmentService = (0, card_details_1.cardShippingShipmentServiceFromJSON)(object.shipmentService);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.reason !== card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON) {
            obj.reason = (0, card_details_1.cardReplacementReasonToJSON)(message.reason);
        }
        if (message.shipmentService !== undefined &&
            message.shipmentService !== card_details_1.CardShippingShipmentService.INVALID_SHIPMENT_SERVICE) {
            obj.shipmentService = (0, card_details_1.cardShippingShipmentServiceToJSON)(message.shipmentService);
        }
        return obj;
    },
    create(base) {
        return exports.ReplaceCardWithShippingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReplaceCardWithShippingRequest();
        message.cardId = object.cardId ?? '';
        message.reason = object.reason ?? card_details_1.CardReplacementReason.INVALID_CARD_REPLACEMENT_REASON;
        message.shipmentService = object.shipmentService ??
            card_details_1.CardShippingShipmentService.INVALID_SHIPMENT_SERVICE;
        return message;
    },
};
function createBaseReplaceCardWithShippingResponse() {
    return { replacement: card_1.Card.fromPartial({}), updated: card_1.Card.fromPartial({}) };
}
exports.ReplaceCardWithShippingResponse = {
    fromJSON(object) {
        const message = {
            replacement: isSet(object.replacement)
                ? card_1.Card.fromJSON(object.replacement)
                : card_1.Card.fromPartial({}),
            updated: isSet(object.updated) ? card_1.Card.fromJSON(object.updated) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.replacement !== undefined) {
            obj.replacement = card_1.Card.toJSON(message.replacement);
        }
        if (message.updated !== undefined) {
            obj.updated = card_1.Card.toJSON(message.updated);
        }
        return obj;
    },
    create(base) {
        return exports.ReplaceCardWithShippingResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReplaceCardWithShippingResponse();
        message.replacement = (object.replacement !== undefined && object.replacement !== null)
            ? card_1.Card.fromPartial(object.replacement)
            : card_1.Card.fromPartial({});
        message.updated = (object.updated !== undefined && object.updated !== null)
            ? card_1.Card.fromPartial(object.updated)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseActivateCardRequest() {
    return { cardId: '' };
}
exports.ActivateCardRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        return obj;
    },
    create(base) {
        return exports.ActivateCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivateCardRequest();
        message.cardId = object.cardId ?? '';
        return message;
    },
};
function createBaseActivateCardResponse() {
    return { card: card_1.Card.fromPartial({}) };
}
exports.ActivateCardResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? card_1.Card.fromJSON(object.card) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = card_1.Card.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.ActivateCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivateCardResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? card_1.Card.fromPartial(object.card)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseUpdateCardRequest() {
    return { cardId: '', cardStatus: card_details_1.CardStatus.INVALID_CARD_STATUS };
}
exports.UpdateCardRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.cardStatus)) {
            message.cardStatus = (0, card_details_1.cardStatusFromJSON)(object.cardStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.cardStatus !== undefined && message.cardStatus !== card_details_1.CardStatus.INVALID_CARD_STATUS) {
            obj.cardStatus = (0, card_details_1.cardStatusToJSON)(message.cardStatus);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCardRequest();
        message.cardId = object.cardId ?? '';
        message.cardStatus = object.cardStatus ?? card_details_1.CardStatus.INVALID_CARD_STATUS;
        return message;
    },
};
function createBaseUpdateCardResponse() {
    return { card: card_1.Card.fromPartial({}) };
}
exports.UpdateCardResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? card_1.Card.fromJSON(object.card) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = card_1.Card.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCardResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? card_1.Card.fromPartial(object.card)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseCloseCardRequest() {
    return { cardId: '' };
}
exports.CloseCardRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        return obj;
    },
    create(base) {
        return exports.CloseCardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCloseCardRequest();
        message.cardId = object.cardId ?? '';
        return message;
    },
};
function createBaseCloseCardResponse() {
    return {};
}
exports.CloseCardResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CloseCardResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCloseCardResponse();
        return message;
    },
};
function createBaseUpdateCardAtmRequest() {
    return { cardId: '', enabled: undefined, pinStatus: card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS };
}
exports.UpdateCardAtmRequest = {
    fromJSON(object) {
        const message = {
            cardId: isSet(object.cardId) ? globalThis.String(object.cardId) : '',
        };
        if (isSet(object.enabled)) {
            message.enabled = Boolean(object.enabled);
        }
        if (isSet(object.pinStatus)) {
            message.pinStatus = (0, card_atm_1.cardPinStatusFromJSON)(object.pinStatus);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.enabled !== undefined) {
            obj.enabled = message.enabled;
        }
        if (message.pinStatus !== undefined && message.pinStatus !== card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS) {
            obj.pinStatus = (0, card_atm_1.cardPinStatusToJSON)(message.pinStatus);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCardAtmRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCardAtmRequest();
        message.cardId = object.cardId ?? '';
        message.enabled = object.enabled ?? undefined;
        message.pinStatus = object.pinStatus ?? card_atm_1.CardPinStatus.INVALID_CARD_PIN_STATUS;
        return message;
    },
};
function createBaseUpdateCardAtmResponse() {
    return { card: card_1.Card.fromPartial({}) };
}
exports.UpdateCardAtmResponse = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card) ? card_1.Card.fromJSON(object.card) : card_1.Card.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = card_1.Card.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateCardAtmResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateCardAtmResponse();
        message.card = (object.card !== undefined && object.card !== null)
            ? card_1.Card.fromPartial(object.card)
            : card_1.Card.fromPartial({});
        return message;
    },
};
function createBaseGetFeesRequest() {
    return { currency: '', shippingAddress: undefined };
}
exports.GetFeesRequest = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency) ? globalThis.String(object.currency) : '',
        };
        if (isSet(object.shippingAddress)) {
            message.shippingAddress = address_1.Address.fromJSON(object.shippingAddress);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== '') {
            obj.currency = message.currency;
        }
        if (message.shippingAddress !== undefined) {
            obj.shippingAddress = address_1.Address.toJSON(message.shippingAddress);
        }
        return obj;
    },
    create(base) {
        return exports.GetFeesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFeesRequest();
        message.currency = object.currency ?? '';
        message.shippingAddress =
            (object.shippingAddress !== undefined && object.shippingAddress !== null)
                ? address_1.Address.fromPartial(object.shippingAddress)
                : undefined;
        return message;
    },
};
function createBaseGetFeesResponse() {
    return { cardFees: [] };
}
exports.GetFeesResponse = {
    fromJSON(object) {
        const message = {
            cardFees: globalThis.Array.isArray(object?.cardFees)
                ? object.cardFees.map((e) => card_fee_1.CardFee.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardFees?.length) {
            obj.cardFees = message.cardFees.map((e) => card_fee_1.CardFee.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetFeesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetFeesResponse();
        message.cardFees = object.cardFees?.map((e) => card_fee_1.CardFee.fromPartial(e)) || [];
        return message;
    },
};
/**
 * Card Service API.
 *
 * Manages user cards. Each card is associated with an account that needs to
 * be created first.
 */
class CardServiceClient {
    rpc;
    name = 'com.step.card.proto.CardService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/card';
    methods = [{
            name: 'GetCardTemplate',
            requestType: exports.GetCardTemplateRequest,
            responseType: exports.GetCardTemplateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetCardTemplate',
            requestType: exports.SetCardTemplateRequest,
            responseType: exports.SetCardTemplateResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetCards',
            requestType: exports.GetCardsRequest,
            responseType: exports.GetCardsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Issue',
            requestType: exports.IssueCardRequest,
            responseType: exports.IssueCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Replace',
            requestType: exports.ReplaceCardRequest,
            responseType: exports.ReplaceCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'ReplaceWithShipping',
            requestType: exports.ReplaceCardWithShippingRequest,
            responseType: exports.ReplaceCardWithShippingResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Activate',
            requestType: exports.ActivateCardRequest,
            responseType: exports.ActivateCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Update',
            requestType: exports.UpdateCardRequest,
            responseType: exports.UpdateCardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'UpdateCardAtm',
            requestType: exports.UpdateCardAtmRequest,
            responseType: exports.UpdateCardAtmResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'GetFees',
            requestType: exports.GetFeesRequest,
            responseType: exports.GetFeesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Gets card template that defines card color, signature, etc.
     */
    getCardTemplate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates card template that defines card color, signature, etc.
     */
    setCardTemplate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Returns all of the issued cards for the given account.
     */
    getCards(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Issues a new card for the given account.
     */
    issue(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    replace(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Replaces card without regard to the free replacement quota
     * using the requested shipping method.
     */
    replaceWithShipping(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Activates existing card. The card must be activated first before
     * its status can be updated.
     */
    activate(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates existing card. This is also used to cancel the card by
     * setting its status to canceled.
     */
    update(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Sets ATM specific details for the card.
     */
    updateCardAtm(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Gets fees related to cards.
     */
    getFees(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.CardServiceClient = CardServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=card-service.js.map